export default "__VITE_ASSET__526e239c__"